import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lấy kỳ lương hiện tại
export function layKyLuongHienTai(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/ky-luong/hien-tai', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách kỳ lương active
export function layDanhSachKyLuongDangHoatDong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/ky-luong/hoat-dong', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách tất cả kỳ lương
export function layDanhSachKyLuong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/ky-luong/loc/danh-sach', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết kỳ lương
export function layChiTietKyLuong(id: number) {
  try {
    return axiosApi.get('/bang-luong/ky-luong/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo kỳ lương
export function taoKyLuong(params: any) {
  try {
    return axiosApi.post('/bang-luong/ky-luong', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật kỳ lương
export function capNhatKyLuong(id: number, params: any) {
  try {
    return axiosApi.put('/bang-luong/ky-luong/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa kỳ lương
export function xoaKyLuong(id: number) {
  try {
    return axiosApi.delete('/bang-luong/ky-luong/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
